{
  "version": 1,
  "asset_id": "70d500e9-b679-4396-b98b-3b020151e6d0",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/70d500e9-b679-4396-b98b-3b020151e6d0/sleeve-fitzer-1-440.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/70d500e9-b679-4396-b98b-3b020151e6d0/sleeve-fitzer-1-440.webp",
  "original_filename": "sleeve-fitzer-1-440.webp",
  "size": 9100,
  "content_type": "image/webp",
  "created_at": "2026-09-29T01:15:31Z"
}
